'use client';
import { createContext } from 'react';

type ConfigContextType = Record<string, any> | null;

const ConfigContext = createContext<ConfigContextType>(null);

export default ConfigContext;
